import { useNavigate } from 'react-router-dom'
import { frontPaths } from '@/config/frontPaths.ts'
import { Button, Typography } from '@mui/material'

const ForbiddenPage = () => {
  const navigate = useNavigate()

  return (
    <>
      <p>No tiene permisos para ver esta página.</p>
      <Typography variant="body2">
        Si cree que es un error contacte a su administrador.
      </Typography>
      <h2>403</h2>
      <Button onClick={() => navigate(frontPaths.home)}>
        Volver a la página inicial
      </Button>
    </>
  )
}

export default ForbiddenPage
